import { cn } from '@/utils';

import { VersionStates } from '@/components/common/Providers/GraphqlProvider/generated';

interface StateTagProps {
  status: VersionStates;
  labels?: Partial<Record<VersionStates, string>>;
  variant?: 'default' | 'compact';
  className?: string;
}

const defaultLabels: Partial<Record<VersionStates, string>> = {
  [VersionStates.Active]: 'Publicado',
  [VersionStates.Draft]: 'Borrador',
  [VersionStates.Inactive]: 'Inactivo',
};

export const StateTag = ({
  status,
  labels = defaultLabels,
  variant = 'default',
  className,
}: StateTagProps) => {
  const getStatusClasses = (status: VersionStates) => {
    const baseClasses: Partial<Record<VersionStates, string>> = {
      [VersionStates.Active]: 'bg-greenLight text-greenDark',
      [VersionStates.Draft]: 'bg-concrete',
      [VersionStates.Inactive]: 'bg-redLight text-shiraz',
    };
    return baseClasses[status] || '';
  };

  const sizeClasses = variant === 'compact' ? 'px-2 py-1 text-xs' : 'px-3 py-2';

  return (
    <div
      className={cn(
        'rounded-full font-bold capitalize',
        sizeClasses,
        getStatusClasses(status),
        className
      )}
    >
      {labels[status] || status}
    </div>
  );
};
